import { E_RouterNames } from "@/router/types";

export interface IBuildOfflineAlarmHistoryRouterParams {
    companyId: number
    areaId: number
    equipmentId: number
    mappingId: number
    sensorId?: string
    createTime?: string
}

export function buildOfflineAlarmHistoryRouter(params: IBuildOfflineAlarmHistoryRouterParams) {
    return {
        name: E_RouterNames.OfflineAlarmHistory,
        query: params
    }
}
